import React, { useEffect, useState } from "react";
import { Box, Input, Modal, Button, TextArea } from "@sainsburys-tech/fable";
import Headerfile from "../../common/Headerfile";
import Footerfile from "../../common/Footerfile";
import Styles from "./AddTemplate.module.css";
import { useParams } from "react-router-dom";
import { useGetPostsQuery, usePutDataMutation } from "../../../api/apiConfig";
import { useDispatch } from "react-redux";
import { addTemplateValue } from "./AddTemplateSlice";
const EditTemplate = () => {
  const { Id } = useParams();
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const { isSuccess, data: getData } = useGetPostsQuery(`templates/${Id}`);
  const [newPost, { isSuccess: putisSuccess, data: putData }] =
    usePutDataMutation();
  const [apiFlag, setApiFlag] = useState<boolean | undefined>(undefined);
  interface Identity {
    SBTemplateId: string;
    Name: string;
    Description: string;
  }

  interface Configuration {
    TemplateFormat: string;
    Height: string;
    Width: string;
    Image: File | null | Blob;
  }

  interface IState {
    Id: string;
    Identity: {
      SBTemplateId: string;
      Name: string;
      Description: string;
    };
    Configuration: {
      TemplateFormat: string;
      Height: string;
      Width: string;
      Image: File | any;
    };
  }

  useEffect(() => {
    if (isSuccess && getData?.Model) {
      const model = getData.Model as { [key: string]: any }; // Type assertion
      setstIdentity(model.Identity);
      setstConfiguration(model.Configuration);
      setValues({
        Id: model.Id,
        Identity: model.Identity,
        Configuration: model.Configuration
      });
    } else {
      console.log("No data found or error occurred");
    }
  }, [isSuccess, getData]);

  const [stIdentity, setstIdentity] = useState<Identity>({
    SBTemplateId: "",
    Name: "",
    Description: ""
  });
  const [stConfiguration, setstConfiguration] = useState<Configuration>({
    TemplateFormat: "",
    Height: "",
    Width: "",
    Image: null
  });
  const [values, setValues] = useState<IState>({
    Id: "",
    Identity: {
      SBTemplateId: "",
      Name: "",
      Description: ""
    },
    Configuration: {
      TemplateFormat: "",
      Height: "",
      Width: "",
      Image: null
    }
  });

  useEffect(() => {
    if (apiFlag === true) {
      try {
        setApiFlag(false);
      } catch (error) {
        console.error(error);
      }
    }
  }, [apiFlag]);
  const handleChange = (
    name: string,
    value: string | File | Blob,
    type: string
  ) => {
    if (type === "Identity") {
      setstIdentity({ ...stIdentity, [name]: value });
    } else {
      setstConfiguration({ ...stConfiguration, [name]: value });
    }
  };

  const onChangeFile = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const files: FileList | null = e.target.files;
    const file: File | null = files ? files[0] : null;
    if (file) {
      getBase64(file);
    }
  };
  const onLoad = (fileString: string | ArrayBuffer | null): void => {
    let separatedArray: string[] = (fileString as string).split(",");
    handleChange("Image", separatedArray[1], "Configuration");
  };

  const getBase64 = (file: File): void => {
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (): void => {
      onLoad(reader.result);
    };
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setApiFlag(true);
    dispatch(
      addTemplateValue({
        id: Id,
        Identity: stIdentity,
        Configuration: stConfiguration
      })
    );
    if (putisSuccess && putData) {
      const model = putData as { [key: string]: any };
      alert(model.Message);
    }
  };

  return (
    <div>
      <div className={Styles.container}>
        <Headerfile />
        <Box as="div" className={Styles.box}>
          <h5 className={Styles.heading}>Edit Template</h5>
          <form onSubmit={handleSubmit}>
            <label className={Styles.label}>
              <Input
                name="TemplateId"
                label="Template Id"
                autocomplete="off"
                value={values.Id}
                type="text"
                isDisabled
                onChange={(e) => handleChange("SBTemplateId", e, "Identity")}
              />
            </label>
            <label className={Styles.label}>
              <Input
                name="SBTemplateId"
                label="Sainsburys Template Id"
                autocomplete="off"
                value={values.Identity.SBTemplateId}
                type="text"
                onChange={(e) => handleChange("SBTemplateId", e, "Identity")}
              />
            </label>
            <label className={Styles.label}>
              <Input
                name="Name"
                label="Template Name"
                autocomplete="off"
                value={values.Identity.Name}
                type="text"
                onChange={(e) => handleChange("Name", e, "Identity")}
              />
            </label>
            <label className={Styles.label}>
              <Input
                name="Description"
                label="Template Description"
                autocomplete="off"
                value={values.Identity.Description}
                type="text"
                onChange={(e) => handleChange("Description", e, "Identity")}
              />
            </label>

            <label className={Styles.label}>
              <TextArea
                name="TemplateFormat"
                label="Template Format"
                onChange={(e) =>
                  handleChange("TemplateFormat", e, "Configuration")
                }
                value={values.Configuration.TemplateFormat}
              />
            </label>
            <label className={Styles.label}>
              <Input
                name="Height"
                label="Height"
                autocomplete="off"
                value={values.Configuration.Height}
                type="text"
                onChange={(e) => handleChange("Height", e, "Configuration")}
              />
            </label>
            <label className={Styles.label}>
              <Input
                name="Width"
                label="Width"
                autocomplete="off"
                value={values.Configuration.Width}
                type="text"
                onChange={(e) => handleChange("Width", e, "Configuration")}
              />
            </label>
            <label className={`${Styles.label} ${Styles.fileLabel}`}>
              Template Image
            </label>
            <img
              alt={values.Configuration.Image}
              src={`data:image/jpeg;base64,${values.Configuration.Image}`}
              height="20%"
              width="30%"
            />
            <br />
            <label className={`${Styles.label} ${Styles.fileLabel}`}>
              Upload Image
            </label>
            <input
              name="Image"
              className={`${Styles.fileInput} form-control form-control-lg`}
              id="formFileLg"
              type="file"
              onChange={onChangeFile}
            />
            <br />
            <Button type="submit" className={Styles.button}>
              Save
            </Button>
          </form>
          <Modal
            isOpen={isOpen}
            onClose={() => setIsOpen}
            layout="default"
            header={{
              isDismissible: true
            }}
          ></Modal>
        </Box>
      </div>

      <Footerfile />
    </div>
  );
};
export default EditTemplate;
